import axios from 'axios'
import { getBackendUrl } from './general'


export const searchProducto = async (context, search) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/searchProducto/?search=${search}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const searchPersonal = async (context, search) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/searchPersonal/?search=${search}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const searchDirectorio = async (context, search) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/searchDirectorio/?search=${search}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}
